import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81759bf8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81759bf8",
  null
  
)

component.options.__file = "index.vue"
export default component.exports